/*
 * GLOBAL THEME VARS
 */
var viewport = $(window).width(),
    viewportHeight = $(window).height(),
    navMinWidth = "",
    navMaxWidth = "",
    navTextTopMin = "",
    navTextTopMax = "",
    navTextRightMin = "",
    navTextRightMax = "",
    navDirection = "up",
    navOpen = false,
    navClickDisabled = false,
    sm = 576,
    md = 768,
    lg = 992,
    xl = 1200,
    gl = 1540,
    loader = $(".ajax-load");